// extracted by mini-css-extract-plugin
module.exports = {"text":"text--F7VkX","editable":"editable--1el-Y"};